const initialState = {
  totalKaryawan: [],
  ambilTotalNominalLunas: [],
  ambilTotalNominalOnGoing: [],
  ambilTotalPenyaluran: [],
  ambilTotalAllPengajuan: [],
  ambilTotalSimpanan: [],
  profitNominal: [],
  profitKuantiti: [],
  trendNominal: [],
  trendKuantiti: [],
  nominalProfitNominal: [],
  nominalProfitKuantiti: [],
  grandTotalProfit: [],
  loadingNominal: false,
  loadingKuantiti: false,
  userTrack: [],
  pengajuanTrack: [],
  rekapSimpanan: [],
  rekapAdmin: [],
  rekapReport: [],
  operationalSummary: {},
};

const dashboardUtamaReducer = (state = initialState, action) => {
  let { type, data } = action;

  switch (type) {
    case "SET_TOTAL_KARYAWAN":
      return {
        ...state,
        totalKaryawan: data,
      };
    case "SET_TOTAL_NOMINAL_LUNAS":
      return {
        ...state,
        ambilTotalNominalLunas: data,
      };
    case "SET_TOTAL_NOMINAL_ONGOING":
      return {
        ...state,
        ambilTotalNominalOnGoing: data,
      };
    case "SET_TOTAL_PENYALURAN":
      return {
        ...state,
        ambilTotalPenyaluran: data,
      };
    case "SET_TOTAL_ALL_PENGAJUAN":
      return {
        ...state,
        ambilTotalAllPengajuan: data,
      };
    case "SET_TOTAL_SIMPANAN":
      return {
        ...state,
        ambilTotalSimpanan: data,
      };
    case "SET_GRAND_TOTAL_PROFIT":
      return {
        ...state,
        grandTotalProfit: data.grandTotal,
      };

    case "GET_PROFIT_PUGAR_NOMINAL_SUCCESS":
      return {
        ...state,
        profitNominal: action.data.data,
      };

    case "GET_PROFIT_PUGAR_KUANTITI_SUCCESS":
      return {
        ...state,
        profitKuantiti: action.data.data,
      };

    case "GET_TREND_PUGAR_NOMINAL_SUCCESS":
      return {
        ...state,
        trendNominal: action.data.data,
      };

    case "GET_TREND_PUGAR_KUANTITI_SUCCESS":
      return {
        ...state,
        trendKuantiti: action.data.data,
      };

    case "GET_PROFIT_NOMINAL_PUGAR_NOMINAL_SUCCESS":
      return {
        ...state,
        nominalProfitNominal: action.data.data,
      };

    case "GET_PROFIT_NOMINAL_PUGAR_KUANTITI_SUCCESS":
      return {
        ...state,
        nominalProfitKuantiti: action.data.data,
      };
    case "SET_USER_TRACK":
      return {
        ...state,
        userTrack: action.data,
      };
    case "SET_PENGAJUAN_TRACK":
      return {
        ...state,
        pengajuanTrack: action.data,
      };
    case "SET_REKAP_SIMPANAN":
      return {
        ...state,
        rekapSimpanan: action.data,
      };
    case "SET_REKAP_ADMIN":
      return {
        ...state,
        rekapAdmin: action.data,
      };
    case "SET_REKAP_REPORT":
      return {
        ...state,
        rekapReport: action.data,
      };
    case "SET_OPERATIONAL_SUMMARY":
      return {
        ...state,
        operationalSummary: action.data,
      };

    default:
      return state;
  }
};

export default dashboardUtamaReducer;
